import { useTranslation } from '@threatadvisor/react-utils';
import { Typography } from 'antd';
import groupBy from 'lodash-es/groupBy';
import React, { ReactElement } from 'react';

import { useCubeQuery } from '@cubejs-client/react';
import { Chart, VizState } from '@threatadvisor/react-components';

type StatusReportParams = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function EventClosureStatus(props: StatusReportParams): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const { t } = useTranslation('reports');

  const chartQuery: VizState = {
    chartType: 'column',
    pivotConfig: {
      x: ['security_event.source'],
      y: ['security_event.closedReason', 'measures']
      //fillMissingDates: false
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event.closedReason', 'security_event.source'],
      timeDimensions: [
        {
          dimension: 'security_event.firstActionDate',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.status',
          operator: 'notEquals',
          values: ['New']
        },
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ]
    }
  };

  const { resultSet: data, isLoading } = useCubeQuery(chartQuery.query!);
  const hasMultipleSources =
    Object.keys(groupBy(data?.rawData() ?? [], 'security_event.source')).length > 1;

  const chartConfig = {
    theme: {
      type: 'threatadvisor'
    },
    style: {
      maxWidth: 25
    },
    xField: hasMultipleSources ? 'security_event.source' : 'security_event.closedReason',
    yField: 'security_event.count',
    seriesField: 'security_event.closedReason',
    // colorField: hasMultipleSources ? 'security_event.closedReason' : 'security_event.source',
    // label: {
    //   offset: -200
    // },
    // legend: {
    //   color: {
    //     title: false,
    //     position: 'top',
    //     layout: {
    //       justifyContent: 'flex-end',
    //       alignItems: 'flex-end',
    //       flexDirection: 'column',
    //     },
    //     //rowPadding: 5,
    //   },
    // },
    // ...(!hasMultipleSources ? { tooltip: false } : null)

    axis: {
      // ACROSS THE X Axis... vertical in this case
      x: {
        labelFormatter: (text: string, item: any, index: number) => text ?? 'Undefined'
      },
      y: {
        grid: true
      }
    },
    scale: {
      //...config.scale,
      y: {
        type: 'linear',
        reverse: true
      }
    }
  };

  return (
    <>
      <h2 className="text-uppercase">
        Event Closure {hasMultipleSources ? 'Status by Source' : 'by Status'}
      </h2>

      <figure>
        <Chart
          config={chartQuery}
          chartConfig={{
            colorField: 'series',
            legend: {
              color: {
                itemLabelText: ({ id, label, color }, index) => {
                  return label === 'Undefined' ? 'Promoted' : label;
                }
              }
            },
            tooltip: {
              items: [
                {
                  channel: 'y',
                  labelFormatter: l => {
                    return 'this aint it';
                  }
                }
              ]
            }
          }}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows event closure / resolution reason or if ‘Promoted’ to an existing case.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
